export default __webpack_public_path__ + "static/media/tutorial1.86335a5c.png";